import GoldFeature1 from "../assets/GoldFeature1.svg";
import GoldFeature2 from "../assets/GoldFeature2.svg";
import GoldFeature3 from "../assets/GoldFeature3.svg";
import GoldFeature4 from "../assets/GoldFeature4.svg";

export default function Features() {
    return (
        <div className="flex flex-wrap space-y-4 items-center justify-between mx-2 md:mx-10 py-10 md:px-12 rounded-2xl  mt-20 bg-white shadow-md">
            <div className="w-1/2 lg:w-1/4 flex flex-col items-center">
                <img className="w-14" src={GoldFeature1} />
                <p className="font-black">1000+</p>
                <p>Verified MD Doctors</p>
            </div>
            <div className="w-1/2 lg:w-1/4 flex flex-col items-center">
                <img className="w-14" src={GoldFeature2} />
                <p className="font-black">24x7</p>
                <p>Video Consultations</p>
            </div>
            <div className="w-1/2 lg:w-1/4 flex flex-col items-center">
                <img className="w-14" src={GoldFeature3} />
                <p className="font-black">12+</p>
                <p>Languages</p>
            </div>
            <div className="w-1/2 lg:w-1/4 flex flex-col items-center">
                <img className="w-14" src={GoldFeature4} />
                <p className="font-black">18+</p>
                <p>Specialities</p>
            </div>
        </div>
    );
}
